import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useAppDispatch } from '@redux/hooks';
import { ServiceCookies } from '@services/ServiceCookies';
import { authActions } from '@entities/Auth';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { Button, ButtonThemes } from '@app/shared';
import { apiUser } from '@entities/User';
import { IconSemicircle } from '@koleso-icons';

import styles from './Logput.module.scss';

export const Logout = () => {
  const isMobile = useWindowSizing(990);
  const router = useRouter();
  const dispatch = useAppDispatch();
  const handlerLogout = useCallback(async () => {
    ServiceCookies.removeJWTTokens();
    dispatch(apiUser.util.resetApiState());
    await router.reload();
    dispatch(authActions.reset());
  }, []);

  return (
    <div className={styles.Wrapper}>
      <Button themes={ButtonThemes.Clear} onClick={handlerLogout} className={styles.Content}>
        <IconSemicircle width={18} height={18} />
        <span>{isMobile ? 'Выйти из Личного кабинета' : 'Выйти из кабинета'}</span>
      </Button>
    </div>
  );
};
